import { useEffect, useState } from 'react';
import { RoleEnum, UserDTO } from '../api';
import { useApiClient } from './useApiClient';

const SALES_ROLES = [
	RoleEnum.SALES,
	RoleEnum.SALES_DEALER,
	RoleEnum.SALES_INTERNAL,
];
const BAM_ROLES = [RoleEnum.MASTER, RoleEnum.BACKOFFICE, RoleEnum.AREA_MANAGER];

export const useOpportunityUserFields = (userRole: RoleEnum) => {
	const { apiClient, handleApiResponse } = useApiClient();
	const [allSalesUsersDTO, setAllSalesUsersDTO] = useState<UserDTO[]>([]);
	const [allSegnalatori, setAllSegnalatori] = useState<UserDTO[]>([]);

	const isBam = BAM_ROLES.includes(userRole);
	const isMasterOrBackoffice = [RoleEnum.MASTER, RoleEnum.BACKOFFICE].includes(
		userRole
	);

	useEffect(() => {
		if (!isBam) return;

		handleApiResponse(apiClient.userController.getRegisterUsers())
			.then((users: UserDTO[]) => {
				setAllSalesUsersDTO(users.filter((u) => SALES_ROLES.includes(u.role)));
			})
			.catch(console.error);

		handleApiResponse(apiClient.userController.getRegisterUsersSegnalatore())
			.then((users: UserDTO[]) => {
				setAllSegnalatori(users);
			})
			.catch(console.error);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { allSalesUsersDTO, allSegnalatori, isBam, isMasterOrBackoffice };
};
